import Chip from '@ds/components/feedback/Chip';
import { AssignmentIcon, LockIcon, LockOpenRightIcon } from '@ds/icons';
import { consignmentEnumToName, ConsignmentStatus } from '@utils/enum-transformers';
import React, { ReactNode } from 'react';

import styles from './ConsignmentStatusChip.module.css';

export type StatusChipVariant = 'draft' | 'submitted' | 'completed' | 'unlocked';

const STATUS_TO_VARIANT: Partial<Record<string, StatusChipVariant>> = {
    [ConsignmentStatus.DRAFT]: 'draft',
    [ConsignmentStatus.SUBMITTED]: 'submitted',
    [ConsignmentStatus.LOCKED]: 'completed',
    [ConsignmentStatus.UNLOCKED]: 'unlocked',
};

const VARIANT_TO_ICON: Record<StatusChipVariant, ReactNode> = {
    draft: <AssignmentIcon aria-hidden />,
    submitted: <LockOpenRightIcon aria-hidden />,
    completed: <LockIcon aria-hidden />,
    unlocked: <LockOpenRightIcon aria-hidden />,
};

const ConsignmentStatusChip: React.FC<
    { status: ConsignmentStatus | string | null | undefined } & React.HTMLAttributes<HTMLSpanElement>
> = ({ status, ...rest }) => {
    const label = consignmentEnumToName(status as ConsignmentStatus);
    const variant = STATUS_TO_VARIANT[status ?? ''] ?? null;

    return (
        <span
            className={styles.root}
            data-variant={variant ?? undefined}
        >
            {label && (
                <Chip
                    variant="secondary"
                    startIcon={variant ? VARIANT_TO_ICON[variant] : undefined}
                    {...rest}
                >
                    {label.toUpperCase()}
                </Chip>
            )}
        </span>
    );
};

export default ConsignmentStatusChip;
